export default __webpack_public_path__ + "deb100ec94ec63cec6e7356653d23b14.ttf";